module.exports = __webpack_public_path__ + "img/icon_join_integ.71da9c32.svg";